const BINNYS_CLIENT = "binnys jewellery private limited";

// Key names a row's purchase order may arrive under. Add new spellings here.
const PO_KEYS = ["purchaseOrder", "purchausOrder"];

export const isBinnysClient = (name) =>
  String(name || "").replace(/\s+/g, " ").trim().toLowerCase() === BINNYS_CLIENT;

export const getPurchaseOrder = (row) => {
  for (const key of PO_KEYS) {
    const value = row?.[key];
    if (value != null && String(value).trim() !== "") return String(value).trim();
  }
  return "";
};

// Binnys Jewellery Private Limited orders are identified by their purchase
// order, e.g. "PO-2026-0457 (BJPL)". Falls back to the client name until a
// row carries one, so it starts working as soon as the API sends the key.
export const getClientLabel = (row) => {
  const name = row?.clientName;
  if (!isBinnysClient(name)) return name;
  const po = getPurchaseOrder(row);
  return po ? `${po} (BJPL)` : name;
};
